import { getApiUrl, getFirstDayOfYear, getLastDayOfYear, } from '@/shared/utils/helpers';
import Vue from 'vue';
export async function fetchAllUsers(filters) {
    return await Vue.axios.post(`${getApiUrl('v4')}/admin/users`, filters, {
        params: {
            page: filters.page,
            per_page: filters.per_page,
        },
    });
}
export async function listFeatureFlags(account_id) {
    return Vue.axios.get(`${getApiUrl('v4')}/admin/account/${account_id}/feature_flag`);
}
export async function addFeatureFlag(params) {
    return Vue.axios.post(`${getApiUrl('v4')}/admin/account/${params.account_id}/add_feature_flag`, {
        flag: params.flag,
    });
}
export async function removeFeatureFlag(params) {
    return Vue.axios.post(`${getApiUrl('v4')}/admin/account/${params.account_id}/remove_feature_flag`, {
        flag: params.flag,
    });
}
export async function createAccount(params) {
    return await Vue.axios.post(`${getApiUrl('v4')}/admin/create_account`, params);
}
export async function enableUser(userId) {
    return await Vue.axios.post(`/user/${userId}/enable_user`);
}
export async function disableUser(userId) {
    return await Vue.axios.post(`/user/${userId}/disable_user`);
}
export async function getAccountInfo(accountId) {
    const baseUrl = getApiUrl('v4');
    return await Vue.axios.get(`${baseUrl}/admin/account/${accountId}/account_info`);
}
export async function getAccountPreferences(accountId) {
    const baseUrl = getApiUrl('v4');
    return await Vue.axios.get(`${baseUrl}/admin/account/${accountId}/preferences`);
}
export async function updateAccount(accountId, data) {
    return await Vue.axios.patch(`/accounts/${accountId}/preferences`, data);
}
export async function getCreditConsumptions(params) {
    return await Vue.axios.get(`/credit_histories/${params.accountId}/grouped_by_users`, {
        params: {
            init_date: params.initDate || getFirstDayOfYear().toISOString(),
            end_date: params.endDate || getLastDayOfYear().toISOString(),
            group_by_format: params.groupByFormat || '%Y-%m',
            page: params.page || 1,
        },
    });
}
export async function getCreditConsumptionsGroupedByUser(params) {
    return await Vue.axios.get(`/credit_histories/${params.accountId}`, {
        params: {
            init_date: params.initDate || getFirstDayOfYear().toISOString(),
            end_date: params.endDate || getLastDayOfYear().toISOString(),
            group_by_format: params.groupByFormat || '%Y-%m',
            page: params.page || 1,
            type: params.type,
        },
    });
}
export async function addCreditsToAccount(userId, credits) {
    const credit = {
        ...(credits.click && {
            search_credit: credits.click,
        }),
        ...(credits.export && {
            internal_export_credit: credits.export,
        }),
        expires_date: credits.expiresDate,
        ...(credits.click && { click: credits.click }),
        ...(credits.export && {
            export: credits.export,
        }),
        expiration: credits.expiresDate,
        ...(credits.unlimitedClick && {
            unlimited_click: credits.unlimitedClick,
        }),
        ...(credits.description && { description: credits.description }),
    };
    return await Vue.axios.post(`credits/user/${userId}/create`, {
        id: userId,
        credit,
        operation: 'add_credit',
    });
}
export async function removeCreditsFromAccount(userId, credits) {
    const credit = {
        ...(credits.click && { search_credit: Number(credits.click) }),
        ...(credits.export && { internal_export_credit: Number(credits.export) }),
        ...(credits.click && { click: Number(credits.click) }),
        ...(credits.export && { export: Number(credits.export) }),
        ...(credits.unlimitedClick && {
            invalidate_unlimited_click: credits.unlimitedClick,
        }),
        ...(credits.description && { description: credits.description }),
    };
    return await Vue.axios.post(`credits/user/${userId}/withdrawal`, {
        id: userId,
        credit,
        operation: 'remove_credit',
    });
}
export async function getNpsScores(userId) {
    return Vue.axios
        .get(`/user/nps_scores/${userId}`)
        .then(res => res)
        .catch(err => err);
}
export async function getMixPanelEvents(userId) {
    return Vue.axios
        .get(`/user/mixpanel_events/${userId}`)
        .then(res => res)
        .catch(err => err);
}
export async function getClientSearchs(userId) {
    return Vue.axios
        .get(`/user/client_searches/${userId}`)
        .then(res => res)
        .catch(err => err);
}
export async function getOnlineDays(userId) {
    return Vue.axios
        .get(`/user/online_days/${userId}`)
        .then(res => res)
        .catch(err => err);
}
export async function getBasicMetricInfos(accountId, days = 30) {
    return Vue.axios
        .get(`/user/basic_infos/${accountId}`, { params: { days } })
        .then(res => res)
        .catch(err => err);
}
export async function getInfoSetsCreatedsInLastThirtyDays(accountId, days = 30) {
    return Vue.axios
        .get(`/user/infosets_last_thirty_days/${accountId}`, { params: { days } })
        .then(res => res)
        .catch(err => err);
}
